import { useMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { CentralAssortmentInfoDTO } from '@retail/dashboard/types';
import { mpeApi } from '@retail/mgpris/config';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

interface Props extends QueryOptions {
  assortmentId: number;
  from: string;
  to: string;
}

export function useFetchCentralAssortmentsInfoItems({
  assortmentId,
  from,
  to,
  ...queryOptions
}: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<CentralAssortmentInfoDTO>({
    method: 'GET',
    queryKey: ['dashboard-central-assortment-info', assortmentId, from, to],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.dashboard.centralAssortment.getFullLinkPath(),
      searchParams: {
        assortmentId,
        from,
        to,
      },
    }),
    ...queryOptions,
  });
}
